<template>
    <div>
        <!-- Render dynamic grids -->
        <template v-if="screenWidth <= 852 && images">
            <galleryComponent v-for="(gridImages, index) in splitImagesUnder1247(images)" :key="index" :images="gridImages" />
        </template>
        <template v-else-if="images">
            <galleryComponent v-for="(gridImages, index) in splitImagesIntoGrids(images)" :key="index" :images="gridImages" />
        </template>
    </div>
</template>

<script>
window.galleryLoaded = false;

import galleryComponent from './gallery-component.vue';

export default {
    name: 'GalleryList',
    components: {
        galleryComponent,
    },
    props: {
        galleryId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            images: null,
            screenWidth: window.innerWidth,
        };
    },
    created() {
        fetch(`/dwapi/content/paragraphs/${this.galleryId}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                const result = this.extractImageInfo(data);
                this.images = result;
            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        window.galleryLoaded = true;
    },
    methods: {
        splitImagesUnder1247(images) {
            const imagesCount = images.length;

            if (imagesCount === 1) {
                return [images];
            }

            if (imagesCount === 2) {
                return [images];
            }

            if (imagesCount === 4) {
                return [images];
            }

            const imagesPerGrid = imagesCount - (imagesCount % 2);
            const grids = [];

            for (let i = 0; i < imagesCount; i += imagesPerGrid) {
                grids.push(images.slice(i, i + imagesPerGrid));
            }

            return grids;
        },
        splitImagesIntoGrids(images) {
            const imagesCount = images.length;

            if (imagesCount === 1) {
                return [images];
            }

            if (imagesCount === 2) {
                return [images];
            }

            if (imagesCount === 4) {
                return [images];
            }

            const imagesPerGrid = imagesCount - (imagesCount % 3);
            const grids = [];
            for (let i = 0; i < imagesCount; i += imagesPerGrid) {
                grids.push(images.slice(i, i + imagesPerGrid));
            }

            return grids;
        },
        extractImageInfo(data) {
            const extractedImages = [];

            if (!data || !data.Item || !data.Item.Fields) {
                return extractedImages;
            }

            const fields = data.Item.Fields;
            fields.forEach(field => {
                if (field.Name === 'Images' && field.SystemName === 'Images') {
                    const values = field.Value;
                    values.forEach(value => {
                        const imageField = value.Fields.find(f => f.SystemName === 'Image');
                        const altTextField = value.Fields.find(f => f.SystemName === 'AlternateText');

                        if (imageField && altTextField) {
                            extractedImages.push({
                                img: imageField.Value[0],
                                alt: altTextField.Value,
                                caption: altTextField.Value
                            });
                        }
                    });
                }
            });
            return extractedImages;
        },
        handleResize() {
            this.screenWidth = window.innerWidth;
        },
    }
};
</script>
